"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_web_components_1 = require("@nimles/react-web-components");

var react_select_1 = __importDefault(require("react-select"));

var creatable_1 = __importDefault(require("react-select/creatable"));

var react_2 = require("@emotion/react");

var StandardInput = function StandardInput(_a) {
  var _b = _a.field,
      onChange = _b.onChange,
      value = _b.value,
      field = __rest(_b, ["onChange", "value"]),
      // { name, value, onChange, onBlur }
  _c = _a.form,
      touched = _c.touched,
      errors = _c.errors,
      setFieldValue = _c.setFieldValue,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label = _a.label,
      required = _a.required,
      info = _a.info,
      options = _a.options,
      isMulti = _a.isMulti,
      optionLabel = _a.optionLabel,
      optionValue = _a.optionValue,
      onCreateOption = _a.onCreateOption,
      createLabel = _a.createLabel,
      props = __rest(_a, ["field", "form", "label", "required", "info", "options", "isMulti", "optionLabel", "optionValue", "onCreateOption", "createLabel"]);

  var theme = react_2.useTheme();
  options = options.map(function (o) {
    return {
      label: optionLabel ? optionLabel(o) : o.label || o.name,
      value: optionValue ? optionValue(o) : o.value
    };
  });
  value = value && (isMulti ? value.map(function (v) {
    return options.find(function (o) {
      return o.value === v;
    }) || {
      label: v,
      value: v
    };
  }) : options.find(function (o) {
    return o.value === value;
  }) || {
    label: value,
    value: value
  });

  var handleChange = function handleChange(input, _a) {
    var action = _a.action;

    var _b;

    var value;

    if (!input) {
      value = isMulti ? [] : '';
    } else if (Array.isArray(input)) {
      value = isMulti ? input.map(function (i) {
        return i.value;
      }) : ((_b = input[0]) === null || _b === void 0 ? void 0 : _b.value) || '';
    } else {
      value = isMulti ? [input.value] : input.value;
    }

    setFieldValue(field.name, value);
  };

  var customStyles = {
    valueContainer: function valueContainer(provided) {
      var _a, _b, _c, _d, _e, _f;

      return __assign(__assign({}, provided), {
        padding: (_c = (_b = (_a = theme) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.paddingVertical, _c !== null && _c !== void 0 ? _c : react_web_components_1.defaultTheme.input.paddingVertical) + "px " + (_f = (_e = (_d = theme) === null || _d === void 0 ? void 0 : _d.input) === null || _e === void 0 ? void 0 : _e.paddingHorizontal, _f !== null && _f !== void 0 ? _f : react_web_components_1.defaultTheme.input.paddingVertical) + "px",
        lineHeight: '21px'
      });
    },
    control: function control(provided, _a) {
      var isFocused = _a.isFocused;

      var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;

      return __assign(__assign({}, provided), {
        boxShadow: isFocused ? "0 0 0 1px " + (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : react_web_components_1.defaultTheme.colors.primary.color) : 'unset',
        borderColor: isFocused ? (_j = (_h = (_g = (_f = theme) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.color, _j !== null && _j !== void 0 ? _j : react_web_components_1.defaultTheme.colors.primary.color) : (_m = (_l = (_k = theme) === null || _k === void 0 ? void 0 : _k.input) === null || _l === void 0 ? void 0 : _l.borderColor, _m !== null && _m !== void 0 ? _m : react_web_components_1.defaultTheme.input.borderColor),
        borderRadius: (_q = (_p = (_o = theme) === null || _o === void 0 ? void 0 : _o.input) === null || _p === void 0 ? void 0 : _p.borderRadius, _q !== null && _q !== void 0 ? _q : react_web_components_1.defaultTheme.input.borderRadius)
      });
    },
    option: function option(provided, _a) {
      var isFocused = _a.isFocused,
          isDisabled = _a.isDisabled,
          isSelected = _a.isSelected;

      var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;

      return __assign(__assign({}, provided), {
        backgroundColor: isDisabled ? null : isSelected ? (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : react_web_components_1.defaultTheme.colors.primary.color) : isFocused ? (_j = (_h = (_g = (_f = theme) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.highlight) === null || _h === void 0 ? void 0 : _h.color, _j !== null && _j !== void 0 ? _j : react_web_components_1.defaultTheme.colors.highlight.color) : null,
        color: isDisabled ? (_o = (_m = (_l = (_k = theme) === null || _k === void 0 ? void 0 : _k.colors) === null || _l === void 0 ? void 0 : _l.highlight) === null || _m === void 0 ? void 0 : _m.color, _o !== null && _o !== void 0 ? _o : react_web_components_1.defaultTheme.colors.highlight.color) : isSelected ? (_s = (_r = (_q = (_p = theme) === null || _p === void 0 ? void 0 : _p.colors) === null || _q === void 0 ? void 0 : _q.primary) === null || _r === void 0 ? void 0 : _r.onColor, _s !== null && _s !== void 0 ? _s : react_web_components_1.defaultTheme.colors.primary.onColor) : (_w = (_v = (_u = (_t = theme) === null || _t === void 0 ? void 0 : _t.colors) === null || _u === void 0 ? void 0 : _u.surface) === null || _v === void 0 ? void 0 : _v.onColor, _w !== null && _w !== void 0 ? _w : react_web_components_1.defaultTheme.colors.surface.onColor)
      });
    },
    singleValue: function singleValue(provided) {
      var _a, _b, _c, _d;

      return __assign(__assign({}, provided), {
        color: (_d = (_c = (_b = (_a = theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.surface) === null || _c === void 0 ? void 0 : _c.onColor, _d !== null && _d !== void 0 ? _d : react_web_components_1.defaultTheme.colors.surface.onColor)
      });
    },
    input: function input(provided) {
      return __assign(__assign({}, provided), {
        padding: 0,
        margin: 0
      });
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, label && react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label), react_1.default.createElement("div", null, onCreateOption ? react_1.default.createElement(creatable_1.default, __assign({
    styles: customStyles,
    required: required,
    options: options
  }, field, props, {
    value: value,
    onChange: handleChange,
    onCreateOption: onCreateOption,
    formatCreateLabel: createLabel ? function (input) {
      return createLabel + " " + input;
    } : undefined,
    isMulti: isMulti
  })) : react_1.default.createElement(react_select_1.default, __assign({
    styles: customStyles,
    required: required,
    options: options
  }, field, props, {
    value: value,
    onChange: handleChange,
    isMulti: isMulti
  })), react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.ReactSelectField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: StandardInput
  }));
};